import { SkewLoader } from "react-spinners";

const Loader = ({ show }) => {
  if (!show) return null;

  return (
    <div style={styles.overlay}>
      <SkewLoader color="#2c3e50" size={25} />
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    width: "100vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(255, 255, 255, 0.6)", // Optional: soft white backdrop
    zIndex: 9999,
  },
};

export default Loader;
